import * as React from "react";
import type { SVGProps } from "react";
const SvgTelegram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={140}
    height={140}
    fill="none"
    {...props}
  >
    <path
      fill="url(#telegram_svg__a)"
      d="M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60"
    />
    <path
      fill="#C8DAEA"
      d="M49 87.5c-1.944 0-1.614-.734-2.284-2.585L41 66.103 85 40"
    />
    <path
      fill="#A9C9DD"
      d="M49 87.5c1.5 0 2.163-.686 3-1.5l8-7.78-9.979-6.017"
    />
    <path
      fill="url(#telegram_svg__b)"
      d="M50.02 72.205 74.2 90.069c2.76 1.523 4.75.734 5.438-2.561l9.842-46.382c1.008-4.04-1.54-5.873-4.18-4.674L27.505 58.737c-3.945 1.583-3.921 3.784-.719 4.764l14.832 4.63 34.336-21.663c1.621-.983 3.11-.455 1.888.63"
    />
    <defs>
      <linearGradient
        id="telegram_svg__a"
        x1={80.04}
        x2={50.04}
        y1={20.04}
        y2={90}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37AEE2" />
        <stop offset={1} stopColor="#1E96C8" />
      </linearGradient>
      <linearGradient
        id="telegram_svg__b"
        x1={67.522}
        x2={76.885}
        y1={60.005}
        y2={81.339}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EFF7FC" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgTelegram;
